export default __webpack_public_path__ + "static/media/dani_s.1e9c076c.jpg";